import React, { useEffect, useCallback } from "react";
import Card from "components/card";
import { MdCheckCircle, MdTimer } from "react-icons/md";
import { useAprendizado } from "context/AprendizadoContext";
import { useDevices } from "context/DeviceContext"; 
import { useSelectedDevice } from "context/SelectedDeviceContext";

export default function Aprendizado() {
  const { selectedDeviceId } = useSelectedDevice();
  const { aprendizadoData, atualizarAprendizado } = useAprendizado();
  const { devices } = useDevices();

  const calcularSemana = useCallback((dataCadastro: string): number => {
    const inicio = new Date(dataCadastro);
    const hoje = new Date();
    const diffDias = Math.floor((hoje.getTime() - inicio.getTime()) / (1000 * 60 * 60 * 24));
    return Math.min(4, Math.floor(diffDias / 7) + 1);
  }, []);

  const getStatus = useCallback((dataCadastro: string): "Operacional" | "Aprendendo" => {
    return calcularSemana(dataCadastro) >= 4 ? "Operacional" : "Aprendendo";
  }, [calcularSemana]);

  const formatarData = (isoDate: string) => {
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  const statusIcon = (status: string) => {
    switch (status) {
      case "Operacional":
        return <MdCheckCircle className="text-green-500" />;
      case "Aprendendo":
        return <MdTimer className="text-blue-500" />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const atualizarStatusOperacional = async () => {
      for (const item of aprendizadoData) {
        const statusAtual = getStatus(item.dataCadastro);
        if (statusAtual === "Operacional" && item.status !== "Operacional") {
          await atualizarAprendizado(item.id, { status: "Operacional" });
        }
      }
    };

    atualizarStatusOperacional();
  }, [aprendizadoData, atualizarAprendizado, getStatus]);

  const aprendizadoFiltrado = selectedDeviceId
    ? aprendizadoData.filter((item) => item.dispositivoId === selectedDeviceId)
    : aprendizadoData;

  return (
    <Card extra="w-full p-4 h-full">
      <h4 className="text-xl font-bold text-navy-700 mb-4">
        Aprendizado
      </h4>

      {aprendizadoFiltrado.length === 0 ? (
        <div className="text-gray-500 text-center py-8">
          {selectedDeviceId 
            ? "Nenhum dispositivo em aprendizado para o filtro atual." 
            : "Nenhum dispositivo em aprendizado encontrado."
          }
        </div>
      ) : (
        <div className="overflow-y-auto max-h-[280px]">
          <table className="w-full text-left">
            <thead>
              <tr className="text-sm font-bold text-gray-600">
                <th>Dispositivo</th>
                <th>Status</th>
                <th>Data Início</th>
                <th>Execução</th>
                {/* <th>Média</th> */}
              </tr>
            </thead>
            <tbody>
              {aprendizadoFiltrado.map((item) => {
                const semanaAtual = calcularSemana(item.dataCadastro);
                const statusAtual = getStatus(item.dataCadastro);
                const device = devices.find((d) => d.id === item.dispositivoId);

                return (
                  <tr key={item.id} className="border-t">
                    <td className="text-sm font-bold text-navy-700">
                      {device?.name || item.nome}
                    </td>
                    <td className="text-sm font-bold text-navy-700 flex items-center gap-1 py-2">
                      {statusIcon(statusAtual)} {statusAtual}
                    </td>
                    <td className="text-sm font-bold text-navy-700">
                      {formatarData(item.dataCadastro)}
                    </td>
                    <td className="text-sm font-bold text-navy-700">
                      {`Semana ${semanaAtual}/4`}
                    </td>
                    {/* <td className="text-sm font-bold text-navy-700">
                      {item.mediaPessoasPorDia > 0 
                        ? `${item.mediaPessoasPorDia} Pes/Dia` 
                        : "- Pes/Dia"
                      }
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}

